import React from "react";
import withStyles from "@material-ui/styles/withStyles";

import { Grid } from "@material-ui/core";

// import ApexChart from "./Samples/ApexChart";

import { styles } from "./Dashboard.styles";
//import Summary from "./Samples/Summary";
import RaspberryInfo from "./modules/RaspberryInfo";
import LastReadings from "./modules/LastReadings";
import IpmaWeather from "./modules/IpmaWeather";

function Dashboard({ classes }) {
  return (
    <div className={classes.root}>
      <Grid container spacing={1}>
        {/* <Grid item xs={6}>
          <Summary />
        </Grid> */}
        <Grid item sm={3} xs={12}>
          {/* <ApexChart /> */}
          <IpmaWeather />
        </Grid>
        <Grid item sm={3} xs={12}>
          <LastReadings />
        </Grid>

        <Grid item sm={3} xs={12}>
          <RaspberryInfo />
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(styles)(Dashboard);
